(() => {
  const initializeLanding = (root) => {
    const menuButton = root.querySelector('.mobile-menu');
    const navigation = root.querySelector('.desktop-nav');

    if (menuButton && navigation) {
      const closeMenu = () => {
        navigation.classList.remove('is-open');
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Open menu');
      };

      menuButton.addEventListener('click', () => {
        const isOpen = navigation.classList.toggle('is-open');
        menuButton.setAttribute('aria-expanded', String(isOpen));
        menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      });

      navigation.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
          closeMenu();
          menuButton.focus();
        }
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth > 980) closeMenu();
      });
    }

    const faqItems = [...root.querySelectorAll('.faq-list details')];
    faqItems.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        faqItems.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    const rfqForm = root.querySelector('#RynsingRfqForm');
    const trapField = rfqForm?.querySelector('[data-rfq-trap]');
    const emailField = rfqForm?.querySelector('#rfq-business-email');
    const freeEmailDomains = new Set([
      '126.com',
      '163.com',
      'aol.com',
      'foxmail.com',
      'gmail.com',
      'hotmail.com',
      'icloud.com',
      'live.com',
      'me.com',
      'outlook.com',
      'proton.me',
      'protonmail.com',
      'qq.com',
      'yahoo.com',
    ]);

    const validateCompanyEmail = () => {
      if (!emailField) return;
      const domain = emailField.value.trim().toLowerCase().split('@').pop();
      const usesFreeEmail = domain && freeEmailDomains.has(domain);
      emailField.setCustomValidity(usesFreeEmail ? 'Please use a company email address.' : '');
    };

    emailField?.addEventListener('input', validateCompanyEmail);
    emailField?.addEventListener('blur', validateCompanyEmail);

    if (rfqForm) {
      const submitButton = rfqForm.querySelector('.rfq-submit');
      const submitStatus = rfqForm.querySelector('[data-rfq-status]');
      let submitting = false;
      let pendingTimer;
      const deliveryUnknown = () => {
        clearTimeout(pendingTimer);
        submitting = false;
        rfqForm.removeAttribute('aria-busy');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Send RFQ for review';
        }
        if (submitStatus) {
          submitStatus.hidden = false;
          submitStatus.textContent = 'No confirmation received yet. Your RFQ may have been sent. Complete any open verification, or contact sales@rynsing.com before submitting again.';
        }
      };
      rfqForm.addEventListener('submit', (event) => {
        validateCompanyEmail();
        if (submitting || trapField?.value.trim() || !rfqForm.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!submitting) rfqForm.reportValidity();
          return;
        }
        submitting = true;
        rfqForm.setAttribute('aria-busy', 'true');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Sending RFQ...';
        }
        if (submitStatus) {
          submitStatus.hidden = false;
          submitStatus.textContent = 'Sending your inquiry. Please complete any verification that appears and keep this page open. Do not submit again.';
        }
        // Shopify owns CAPTCHA and the native POST. Do not replace either with an AJAX submission.
        pendingTimer = setTimeout(deliveryUnknown, 90000);
      }, true);
      window.addEventListener('pageshow', (event) => {
        if (event.persisted && submitting) deliveryUnknown();
      });
    }

    const errorPanel = root.querySelector('[data-rfq-errors]');
    if (errorPanel) {
      errorPanel.focus({ preventScroll: true });
      errorPanel.scrollIntoView({ behavior: 'instant', block: 'center' });
    }
    const successPanel = root.querySelector('[data-rfq-success]');
    if (successPanel) {
      // Customer feedback must run before optional tracking, even when analytics throws.
      const revealConfirmation = () => {
        successPanel.focus({ preventScroll: true });
        successPanel.scrollIntoView({ behavior: 'instant', block: 'center' });
      };
      revealConfirmation();
      window.addEventListener('pageshow', revealConfirmation);
      const readSession = (key) => {
        try { return sessionStorage.getItem(key); } catch { return null; }
      };
      const writeSession = (key) => {
        try { sessionStorage.setItem(key, 'sent'); } catch { /* Storage may be blocked. */ }
      };
      const eventKey = 'rynsing-h1000-c-rfq-lead';
      if (readSession(eventKey) !== 'sent') {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'generate_lead', form_name: 'H1000-C B2B RFQ' });
          writeSession(eventKey);
        } catch { /* Analytics must not block the confirmation or other tracking. */ }
      }
      const pixelEventKey = 'rynsing-h1000-c-pixel-lead';
      let attempts = 0;
      const publishLead = () => {
        if (readSession(pixelEventKey) === 'sent') return;
        attempts += 1;
        try {
          const analytics = window.Shopify?.analytics;
          if (typeof analytics?.publish === 'function'
            && analytics.publish('rynsing:rfq_success', { content_name: 'H1000-C B2B RFQ' }) !== false) {
            writeSession(pixelEventKey);
            return;
          }
        } catch { /* Tracking must not interrupt the RFQ confirmation. */ }
        if (attempts < 40) setTimeout(publishLead, 250);
      };
      publishLead();
    }
  };

  document.querySelectorAll('[data-rynsing-landing]').forEach(initializeLanding);
})();
